import * as z from 'zod'

import { LOCALES } from '@/lib/localization/constants'
import { UTMDataSchema } from '@/lib/gtm'

import { SERVICE_OPTIONS } from './constants'

export const schema = z.object({
  firstName: z.string().nonempty({ message: 'First name is required' }),
  lastName: z.string().nonempty({ message: 'Last name is required' }),
  email: z
    .string()
    .email({ message: 'Must be valid email' })
    .nonempty({ message: 'Email is required' }),
  tel: z.string(),
  additionalDetail: z.string(),
  acceptedTerm: z.boolean(),
  agreedToMarketingConsent: z.boolean(),
  interestedProducts: z.enum(SERVICE_OPTIONS).array(),
})

export type FormValue = z.infer<typeof schema>

export const payloadSchema = schema.extend({
  language: z.enum(LOCALES),
  utm: UTMDataSchema,
})

export type PayloadValue = z.infer<typeof payloadSchema>
